// apps/web/src/components/vendas/guarda-permissao.tsx — Fase 12, WR-D1-07.
// Guarda de rota do cliente: consulta as permissões da sessão e mostra "Sem permissão" ANTES de renderizar a tela de escrita.
// Mesmo padrão de leitura de permissão de `pedidos-lista-page.tsx` (`obterSessaoAtual`). O servidor continua a barreira real.
import { useEffect, useState, type ReactNode } from 'react';
import { Card, CardContent } from '../ui/card';
import { Skeleton } from '../ui/skeleton';
import { obterSessaoAtual } from '../../lib/session';
import { acessoDaRota, MENSAGEM_SEM_PERMISSAO_ROTA, type AcessoRota } from '../../lib/vendas/permissao';

interface GuardaPermissaoProps {
  readonly permissao: string;
  readonly children: ReactNode;
  /** Destino do link de saída quando o acesso é negado (padrão: lista de pedidos de venda). */
  readonly voltar?: { readonly href: string; readonly rotulo: string };
}

export function GuardaPermissao({ permissao, children, voltar = { href: '/vendas/pedidos', rotulo: 'Voltar aos pedidos' } }: GuardaPermissaoProps) {
  const [acesso, setAcesso] = useState<AcessoRota | 'carregando'>('carregando');

  useEffect(() => {
    let vivo = true;
    void obterSessaoAtual().then((sessao) => {
      if (vivo) setAcesso(acessoDaRota(sessao, permissao));
    });
    return () => {
      vivo = false;
    };
  }, [permissao]);

  if (acesso === 'carregando') {
    return (
      <div className="mx-auto w-full max-w-7xl p-6" aria-busy="true" aria-label="Verificando permissão">
        <Skeleton className="h-10 w-64" />
      </div>
    );
  }

  if (acesso === 'negado') {
    return (
      <div className="mx-auto w-full max-w-7xl p-6">
        <Card>
          <CardContent role="alert" className="flex flex-col items-center gap-4 py-12 text-center">
            <p className="text-sm text-rose-700">{MENSAGEM_SEM_PERMISSAO_ROTA}</p>
            <a className="text-sm underline" href={voltar.href}>
              {voltar.rotulo}
            </a>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
